import { type FunctionalComponent, h } from '@stencil/core';
import { ConversationalSearchLabelWithSection } from '../../../conversational-search/conversational-search-partials/label-with-section/label-with-section';
import mia from '../assets/mia.svg'; // It is needed because qds4 icons are not part of first phase and qds 3 is not added to header
import type {labelProviderInterface} from '../../../../LabelProviderInterface';

interface IMiaPomotionBanner {
  isProductTabVariant: boolean;
	labelProvider: labelProviderInterface;
	bannerInteractionHandler: Function;
}

export const MiaPomotionBanner: FunctionalComponent<IMiaPomotionBanner> = (
  props,
) => {
    const allTabText = props.labelProvider(
      'additional.mia.banner.subtitle',
      'Search for products that meet criteria for federal funding and Domestic Preference compliance like the Trade Agreements Act (TAA), Buy American Act (BAA), and the Build America, Buy America Act (BABA).',
    );
    const productsTabText = props.labelProvider(
      'additional.mia.banner.subtitle',
      'Search for products that meet criteria for federal funding and Domestic Preference compliance like the (TAA), (BAA), and (BABA).',
    );
    return (
      <div
        class={{
          'additional-conditions-banner': true,
          'additional-conditions-banner--standard-tab': props.isProductTabVariant,
        }}
      >
        <div>
          <section class="additional-conditions-banner-content">
            <span
              class="additional-conditions-banner-content__icon"
              innerHTML={mia}
            />
            <section>
              {!props.isProductTabVariant && [
                <div class="additional-conditions-banner-content-header">
                  <strong class="additional-conditions-banner-content-header__title">
                    {props.labelProvider(
                      'additional.mia.banner.title',
                      'Discover Domestic Preference Compliant Products',
                    )}
                  </strong>
                </div>,
                <div class="additional-conditions-banner-content__subtitle">
                  <ConversationalSearchLabelWithSection text={allTabText} />
                </div>
              ]}
              {props.isProductTabVariant && <div class="additional-conditions-banner-content__subtitle">
                <ConversationalSearchLabelWithSection text={productsTabText} />
              </div>}
            </section>
          </section>
          <section class="additional-conditions-banner__button-section">
            <qds-button
              class="additional-conditions-banner__button"
              size="large"
              importance="emphasized"
              onClick={() => props.bannerInteractionHandler()}
              text={props.labelProvider(
                'additional.conditions.banner.cta',
                'Show products',
              )}
            ></qds-button>
          </section>
        </div>
      </div>
    );
};
